import { Timeline as ChakraTimeline } from '@chakra-ui/react';
import * as React from 'react';

export const TimelineConnector = React.forwardRef<
  HTMLDivElement,
  ChakraTimeline.IndicatorProps
>(function TimelineConnector(props, ref) {
  return (
    <ChakraTimeline.Connector ref={ref}>
      <ChakraTimeline.Separator />
      <ChakraTimeline.Indicator {...props} />
    </ChakraTimeline.Connector>
  );
});

export const TimelineRoot = ChakraTimeline.Root;
export const TimelineContent = ChakraTimeline.Content;
// export const TimelineItem = ChakraTimeline.Item;
export const TimelineIndicator = ChakraTimeline.Indicator;
export const TimelineTitle = ChakraTimeline.Title;
export const TimelineDescription = ChakraTimeline.Description;

export interface TimelineItemProps {
  leftTitle: React.ReactNode | string;
  contentTitle: React.ReactNode | string;
  description: React.ReactNode | string;
  indicator: React.ReactNode | string;
  children: React.ReactNode;
}

export const TimelineItem = React.forwardRef<HTMLDivElement, TimelineItemProps>(
  function Timeline(props, ref) {
    const { leftTitle, contentTitle, indicator, description, children } = props;
    return (
      <>
        <ChakraTimeline.Item>
          <ChakraTimeline.Content width="auto">
            <ChakraTimeline.Title whiteSpace="nowrap">
              {leftTitle}
            </ChakraTimeline.Title>
          </ChakraTimeline.Content>
          <ChakraTimeline.Connector>
            <ChakraTimeline.Separator />
            <ChakraTimeline.Indicator>{indicator}</ChakraTimeline.Indicator>
          </ChakraTimeline.Connector>
          <ChakraTimeline.Content>
            <ChakraTimeline.Title>{contentTitle}</ChakraTimeline.Title>
            <ChakraTimeline.Description>
              {description}
            </ChakraTimeline.Description>
            {children}
          </ChakraTimeline.Content>
        </ChakraTimeline.Item>
      </>
    );
  },
);
